
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/frett/[uid]",
      function () {
        return require("private-next-pages/frett/[uid].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/frett/[uid]"])
      });
    }
  